import { render } from "./Code.vue?vue&type=template&id=0ebf51e6"
const script = {}
script.render = render

export default script